import React, { useMemo } from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import Select from "react-select"
import OptionSwitch from "./OptionSwitch"
import { DOWNLOAD_TYPES, INPUTS } from "hooks/budgeting/useDownloadBudgetConfig"
import { Badge, Tooltip } from "@mui/material"
import {
  optionBoxStyle,
  optionSelectStyle,
  optionSelectWrapper,
} from "components/Documents/StylesAndUtils/CustomStyles"

const BC3Options = ({
  setDownloadBudgetConfig,
  addCostsRef,
  addCosts,
  setAddCosts,
  addMeasurements,
  setAddMeasurements,
  addDecompositions,
  setAddDecompositions,
  simpleMode,
  setSimpleMode,
}) => {
  const tipo = DOWNLOAD_TYPES.BC3
  const selectAddCostsOptions = [
    { value: false, label: i18n.t("downloadBudget.clientPrice") },
    { value: true, label: i18n.t("downloadBudget.targetCost") },
  ]
  const options = useMemo(
    () => [
      {
        i18nKey: "downloadBudget.exportMeasurements",
        state: addMeasurements,
        setState: setAddMeasurements,
        inputKey: INPUTS.EXPORT_MEASUREMENTS,
      },
      {
        i18nKey: "downloadBudget.exportDecompositions",
        state: addDecompositions,
        setState: setAddDecompositions,
        inputKey: INPUTS.EXPORT_DECOMPOSITIONS,
      },
    ],
    [
      addMeasurements,
      setAddMeasurements,
      addDecompositions,
      setAddDecompositions,
    ],
  )

  return (
    <>
      <OptionSwitch
        key={`bc3_${INPUTS.SIMPLE_MODE}`}
        i18nKey="downloadBudget.simpleMode"
        state={simpleMode}
        setState={setSimpleMode}
        inputKey={INPUTS.SIMPLE_MODE}
        tipo={tipo}
        setDownloadBudgetConfig={setDownloadBudgetConfig}
      />

      {simpleMode && (
        <div
          id="Poppinsnormal"
          style={{ ...optionBoxStyle, height: "115px", marginTop: "10px" }}
        >
          <Tooltip title={i18n.t("downloadBudget.tooltipWarning")}>
            <Badge
              color="secondary"
              badgeContent="!"
              style={{ marginLeft: "5px", top: "15px" }}
            />
          </Tooltip>
          <div style={{ marginLeft: "20px", fontFamily: "Helvetica" }}>
            {i18n.t("downloadBudget.simpleModeDescription")}
          </div>
        </div>
      )}

      {!simpleMode && (
        <>
          <div style={optionSelectWrapper}>
            <Select
              ref={addCostsRef}
              options={selectAddCostsOptions}
              styles={optionSelectStyle}
              value={
                addCosts
                  ? selectAddCostsOptions.find(o => o.value === addCosts)
                  : selectAddCostsOptions[0]
              }
              onChange={e => {
                setAddCosts(e.value)
                setDownloadBudgetConfig(tipo, INPUTS.USE_COSTS, e.value)
                addCostsRef.current.blur()
              }}
            />
          </div>
          {options.map(({ i18nKey, state, setState, inputKey }) => (
            <OptionSwitch
              key={`bc3_${inputKey}`}
              i18nKey={i18nKey}
              state={state}
              setState={setState}
              inputKey={inputKey}
              tipo={tipo}
              setDownloadBudgetConfig={setDownloadBudgetConfig}
            />
          ))}
        </>
      )}
    </>
  )
}

BC3Options.propTypes = {
  setDownloadBudgetConfig: PropTypes.func.isRequired,
  addCostsRef: PropTypes.any.isRequired,
  addCosts: PropTypes.bool.isRequired,
  setAddCosts: PropTypes.func.isRequired,
  addMeasurements: PropTypes.bool.isRequired,
  setAddMeasurements: PropTypes.func.isRequired,
  addDecompositions: PropTypes.bool.isRequired,
  setAddDecompositions: PropTypes.func.isRequired,
  simpleMode: PropTypes.bool.isRequired,
  setSimpleMode: PropTypes.func.isRequired,
}

export default BC3Options
